import sets from './sets';
import prefill from './prefill';

export default prefill({
  black: {},
  blue: {},
  green: {},
  pink: {},
  white: {},
  yellow: {},

  convict: { price: 2, set: sets.specialShirts },
  cross: { price: 2, set: sets.legacyShirts },
  fire: { price: 2, set: sets.specialShirts },
  horizon: { price: 2, set: sets.specialShirts },
  ocean: { price: 2, set: sets.specialShirts },
  purple: { price: 2, set: sets.specialShirts },
  rainbow: { price: 2, set: sets.specialShirts },
  redblue: { price: 2, set: sets.specialShirts },
  thunder: { price: 2, set: sets.specialShirts },
  tropical: { price: 2, set: sets.specialShirts },
  zombie: { price: 2, set: sets.specialShirts },
});
